'use strict';

import * as Props from '../Props';

const angular = require('angular');

const TableProperties = {
    Basic: {
        'ControlType': 'Table',
        'Label': {
            name: 'label',
            selectedValue: 'Table',
            type: 'textbox',
            hidden: true
        },
        'Field Name': Props.getFieldName('Table'),
        'Name': {
            selectedValue: 'Basic',
            hideSection: false,
            hidden: true
        }
    },
    Display: {
        'Rows': {
            name: 'Rows',
            selectedValue: 3,
            type: 'number',
            onChangeFunction: 'updateTable'
        },
        'Columns': {
            name: 'Columns',
            selectedValue: 3,
            type: 'number',
            onChangeFunction: 'updateTable',
            min: 1,
            max: 20
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'RemoveOptions': {
            type: 'button-group',
            members: {
                'Remove Width': {
                    type: 'button',
                    title: 'Remove Width',
                    selectedValue: '1',
                    icon: 'fa fa-eraser',
                    onClickFunction: 'removeWidth'
                },
                'Remove': {
                    type: 'button',
                    title: 'Remove',
                    selectedValue: '1',
                    icon: 'fa fa-remove',
                    onClickFunction: 'removeRow'
                }
            }
        },
        'Fit-to-Screen': {
            name: 'fit.to.screen',
            extraClass: 'fit-to-screen',
            selectedValue: false,
            type: 'checkbox',
            icon: 'fa fa-info'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Borders: {
        'border-style-group': {
            type: 'style-group',
            members: {
                'border-width': {
                    type: 'number',
                    title: 'font.size',
                    selectedValue: 1,
                    min: '1',
                    max: '99',
                    default: 1,
                    onChangeFunction: 'updateStyle'
                },
                'border-color': {
                    type: 'color-picker',
                    title: 'border.color',
                    selectedValue: '#cccccc',
                    icon: 'fa fa-paint-brush',
                    onChangeFunction: 'updateStyle'
                }
            }
        },
        'Name': {
            selectedValue: 'Borders',
            hidden: true
        }
    },
    Style: {
        'font-style-group': {
            type: 'style-group',
            members: {
                'background-color': {
                    type: 'color-picker',
                    title: 'background.color',
                    selectedValue: '#ffffff',
                    icon: 'fa fa-paint-brush',
                    onChangeFunction: 'updateStyle'
                }
            }
        },
        'style-group': {
            type: 'style-group',
            members: {}
        },
        'Name': {
            selectedValue: 'style',
            hidden: true
        }
    },
    Margin: angular.copy(Props.marginObject),
    'Merge': {
        'merge': {
            type: 'button-group',
            members: {
                'merge': {
                    title: 'mergeCellMsg',
                    selectedValue: '1',
                    icon: 'fa fa-compress',
                    onClickFunction: 'mergeCell'
                },
                'split': {
                    type: 'button',
                    title: 'split',
                    selectedValue: '1',
                    icon: 'fa fa-expand',
                    onClickFunction: 'splitCell'
                }
            }
        },
        'Name': {
            selectedValue: 'Merge',
            hidden: true
        }
    },
    Events: {
        Name: angular.copy(Props.elementEventsObject).Name,
        load: angular.copy(Props.elementEventsObject).load
    }
};

export default TableProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Table.ts